import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronGrabberVertical: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="chevron-grabber-vertical"><path d="M8 9L12 5L16 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M16 15L12 19L8 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconChevronGrabberVertical;
